import React, { useRef, useEffect, useState } from 'react';
import BackPlate from "../../components/backplate";
import BackTitle from "../../components/backTitle";
import SubNavBar from '../../components/subNavbar';
import Footer from '../../components/footer';

import { Outlet, useNavigate } from 'react-router-dom';
const Homepage = () => {
  const navigate = useNavigate();

  /* useEffect(() => {
    if (window.location.pathname === '/') {
    navigate('/play')
    }
  }, []) */
  return (
    <>
    
      <BackPlate backplateType="play" />
      <div className='content-body'>
      <SubNavBar links={
        [{
          'name': 'Play',
          'link': '/play'
        },
        {
          'name': 'My Games',
          'link': '/games'
        }
        ]
      }
      />
      <Outlet />
      </div>
      <div  className='lg-footer-container' >
        <Footer />
      </div>
    </>
  );

}

export default Homepage;